import { useEffect, useState } from 'react'
import { DropDown } from './'
import { country } from '../../../lookups'
import { country as getCountry } from '../../auth/request.js'

const commonName = {
  AU: "Australia",
  CA: "Canada",
  GB: "United Kingdom",
  IL: "Israel",
  NZ: "New Zealand",
  US: "United States of America",
}

export const CountryDropDown = ({ value, onChange, ...props }) => {
  const [initialValue] = useState(value)

  useEffect(() => {
    if(!initialValue) {
      getCountry().then(({ country }) => onChange(country))
    }                // tricky to ensure the onChange prop doesn't change each render
  }, [initialValue]) // eslint-disable-line

  const formatCountriesList = x => Object.keys(x).map((key) => ({
    label: x[key],
    value: key
  }))

  const commonCountryOptions = formatCountriesList(commonName)
  const countryOptions = formatCountriesList(country.name)
  const countries = commonCountryOptions.concat([{ label: '', value: ''}]).concat(countryOptions)

  return <DropDown
    value={value}
    onChange={onChange}
    options={countries}
    title="Country"
    {...props}
  />
}